import { cn } from '@divlab/divanui';

import Video from '@Components/Video';
import Link from '@UI/Link';
import { open as openModal } from '@Stores/ModalWindows';
import styles from './QualityLaboratoryBanner.module.css';

import type { FC, HTMLAttributes } from 'react';
import type { QualityLaboratoryData } from '../..';

export interface QualityLaboratoryBannerProps extends HTMLAttributes<HTMLDivElement> {
  qualityLaboratoryData: QualityLaboratoryData;
}

const QualityLaboratoryBanner: FC<QualityLaboratoryBannerProps> = (props) => {
  const { className, qualityLaboratoryData, ...restProps } = props;
  const banner = qualityLaboratoryData.banner;

  const handleClick = () => {
    openModal('QualityLaboratory', { qualityLaboratory: qualityLaboratoryData });
  };

  return (
    <div {...restProps} onClick={handleClick} className={cn(styles.wrapper, className)}>
      <Video className={styles.video} autoPlay loop src={qualityLaboratoryData.video} />
      <div className={styles.contentWrapper}>
        <div className={styles.text}>{banner.text}</div>
        <Link className={styles.link} underlined view='white'>
          {banner.button}
        </Link>
      </div>
    </div>
  );
};

export default QualityLaboratoryBanner;
